export default __webpack_public_path__ + "static/media/bookshelf.ea644fd5.svg";